<template>
  <v-app>
    <v-app-bar color="primary" flat app dark>
      <v-spacer></v-spacer>
      <v-app-bar-title style="min-width: fit-content;">{{ $t('memoru.albumListTitle') }}</v-app-bar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-main>
      <v-container class="pa-2">
        <v-row>
          <v-btn
            block
            variant="text"
            color="primary"
            size="large"
            @click="() => isCreateDialogOpen = true"
          >{{ $t('memoru.addAlbumButton') }}</v-btn>
        </v-row>
        <v-progress-linear
          indeterminate
          color="primary"
          height="3"
          v-if="isFetching"
        ></v-progress-linear>
        <v-tabs fixed-tabs v-model="listType" color="primary" class="mt-2">
          <v-tab>{{ $t('memoru.tabAll') }}</v-tab>
          <v-tab>{{ $t('memoru.tabPublished') }}</v-tab>
          <v-tab>{{ $t('memoru.tabUnpublished') }}</v-tab>
        </v-tabs>
        <div>
          <!-- <template
            v-for="(album, i) in albums"
          >
            <v-list-item
              :to="`/album/${album.albumId}`"
            >
              <v-list-item-content>
                <v-list-item-title>{{ album.title }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>mdi-chevron-right</v-icon>
              </v-list-item-icon>
            </v-list-item>
            <v-divider />
          </template> -->
          <template v-for="(album) in albums" :key="album.albumId">
            <v-list-item :to="`/album/${album.albumId}`" style="margin:8px;">
              <v-list-item-title>{{ album.title }}</v-list-item-title>
              
              <template #append>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-list-item>
            
            <v-divider />
          </template>
        </div>
        <v-row class="my-2" v-if="hasMoreAlbums">
          <v-btn
            block
            text
            color="primary"
            large
            @click="loadMore"
          >さらに読み込む</v-btn>
        </v-row>
      </v-container>
    </v-main>

    <v-dialog v-model="isCreateDialogOpen" max-width="720">
      <v-card>
        <v-card-title class="align-center justify-center">
          {{ $t('memoru.createAlbumTitle') }}
        </v-card-title>
        <v-card-text>
          <div class="my-3">
            <span class="mb-2">{{ $t('memoru.year') }}</span>
            <v-text-field 
              type="number"
              density="compact"
              hide-details
              variant="outlined"
              v-model="newAlbumYear"
              color="primary"
              :disabled="newAlbumClassIds && newAlbumClassIds.length > 0"
            />
          </div>
          <div class="my-3">
            <span class="mb-2">{{ $t('memoru.class') }}</span>
            <v-select
              variant="outlined"
              multiple
              density="compact"
              hide-details
              v-model="newAlbumClassIds"
              :items="classes"
              item-value="classId"
              item-title="className"
              color="primary"
            ></v-select>
          </div>
          <div class="my-3">
            <span class="mb-2">{{ $t('memoru.albumTitle') }}</span>
            <v-text-field 
              density="compact"
              hide-details
              variant="outlined"
              v-model="newAlbumTitle"
              color="primary"
            />
          </div>
          <div class="my-3">
            <span class="mb-2">{{ $t('memoru.comment') }}</span>
            <v-text-field 
              density="compact"
              hide-details
              variant="outlined"
              v-model="newAlbumComment"
              color="primary"
            />
          </div>
          <div class="my-3" v-if="!isCreateInClosed">
            <div class="d-flex align-center">
              <span class="mb-2">{{ $t('memoru.publishStartLabel') }}</span>
              <v-spacer />
              <v-checkbox
                :label="$t('memoru.publishNow')"
                v-model="isPublishNow"
                color="primary"
              ></v-checkbox>
            </div>
            <v-text-field
              v-if="!isPublishNow"
              type="datetime-local"
              density="compact"
              hide-details
              variant="outlined"
              v-model="newAlbumAvailableAfter"
              color="primary"
            />
          </div>
          <div class="my-3" v-if="!isCreateInClosed">
            <div class="d-flex align-center">
              <span class="mb-2">{{ $t('memoru.publishEndLabel') }}</span>
              <v-spacer />
              <v-checkbox
                :label="$t('memoru.noLimit')"
                v-model="isPublicForever"
                color="primary"
              ></v-checkbox>
            </div>
            <v-text-field 
              v-if="!isPublicForever"
              type="datetime-local"
              density="compact"
              hide-details
              variant="outlined"
              v-model="newAlbumAvailableBefore"
              color="primary"
            />
          </div>

          <div class="my-2">
            <v-checkbox
              :label="$t('memoru.createAsPrivate')"
              v-model="isCreateInClosed"
              color="primary"
            ></v-checkbox>
          </div>
        </v-card-text>
        <v-progress-linear
          indeterminate
          color="primary"
          height="3"
          v-if="isCreating"
        ></v-progress-linear>
        <v-card-actions>
          <v-btn
            @click="() => isCreateDialogOpen = false"
          >
            {{ $t('common.cancel') }}
          </v-btn>
          <v-spacer />
          <v-btn
            color="primary"
            :disabled="isCreating || !availableAfterValue"
            @click="create"
            variant="flat"
          >
            {{ $t('memoru.create') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>
<script lang="ts">
//import Vue from 'vue';
import { defineComponent } from "vue";

import { PostMeRequest } from '@/model/Request';
import { memoruAlbumsModule } from '@/store/dataModules/memoruAlbumsModule';
import { auth0Module } from '@/store/dataModules/auth0Module';
import LocalDataService from '@/service/LocalDataService';
import { MeNurserySchoolResponse, MultimediaAlbumResponse } from 'chaild-api/lib';
import dayjs from 'dayjs';
import ApiMemoru from '@/api/ApiMemoru';
import { nurseryModule } from '@/store/dataModules/nurseryModule';

interface DataType {
  isCreateDialogOpen: boolean;
  newAlbumYear: number;
  newAlbumTitle: string;
  newAlbumClassIds: Array<string | number>;
  newAlbumComment: string;
  newAlbumAvailableAfter: string | null;
  isPublishNow: boolean;
  newAlbumAvailableBefore: string | null;
  isPublicForever: boolean;
  isCreateInClosed: boolean;
  nurseryId: number | null;
  isCreating: boolean;
  isFetching: boolean;
  listType: number;
}

export default defineComponent({
  computed: {
    albums(): MultimediaAlbumResponse[] {
      const albums = memoruAlbumsModule.albums

      if (this.listType === 1) {
        return this.publishedAlbums
      }

      if (this.listType === 2) {
        return this.unpublishedAlbums
      }

      return albums
    },
    allAlbums(): MultimediaAlbumResponse[] {
      return memoruAlbumsModule.albums
    },
    publishedAlbums(): MultimediaAlbumResponse[] {
      return memoruAlbumsModule.albums.filter((album) => {
        const diff1 = dayjs().diff(dayjs(album.availableAfter), 'day')
        if (album.availableBefore) {
          const diff2 = dayjs().diff(dayjs(album.availableBefore), 'day')
          return diff1 >= 0 && diff2 < 0
        }
        return diff1 >= 0;
      })
    },
    unpublishedAlbums(): MultimediaAlbumResponse[] {
      return memoruAlbumsModule.albums.filter((album) => {
        const diff1 = dayjs().diff(dayjs(album.availableAfter), 'day')
        if (album.availableBefore) {
          const diff2 = dayjs().diff(dayjs(album.availableBefore), 'day')
          return diff1 < 0 || diff2 >= 0
        }
        return diff1 < 0;
      })
    },
    hasMoreAlbums(): boolean {
      if (this.albums.length < memoruAlbumsModule.total) {
        return true;
      }
      return false;
    },
    classes() {
      return nurseryModule.allClasses as readonly any[] | undefined;
    },
    availableAfterValue() {
      if (this.isCreateInClosed || this.isPublishNow) {
        return dayjs().toISOString();
      }
      return this.newAlbumAvailableAfter
    },
    availableBeforeValue() {
      if (this.isCreateInClosed) {
        return dayjs().toISOString();
      }
      if (this.isPublicForever) {
        return null
      }
      return this.newAlbumAvailableBefore
    }
  },
  data: (): DataType => {
    return {
      isCreateDialogOpen: false,
      newAlbumYear: dayjs().year(),
      newAlbumTitle: '',
      newAlbumClassIds: [],
      newAlbumComment: '',
      newAlbumAvailableBefore: null,
      newAlbumAvailableAfter: null,
      isPublishNow: false,
      isPublicForever: false,
      isCreateInClosed: false,
      nurseryId: null,
      isCreating: false,
      isFetching: false,
      listType: 0
    }
  },
  methods: {
    async create() {
      if (this.nurseryId && this.availableAfterValue) {
        this.isCreating = true;
        const response = await ApiMemoru.createAlbum({
          nurseryId: this.nurseryId,
          year: this.newAlbumYear,
          title: this.newAlbumTitle,
          comment: this.newAlbumComment,
          nurseryClassIds: this.newAlbumClassIds,
          availableAfter: this.availableAfterValue,
          availableBefore: this.availableBeforeValue
        })
        this.isCreating = false;
        this.isCreateDialogOpen = false;

        memoruAlbumsModule.listAlbums(this.nurseryId);
      }
    },
    clearCreateValues() {
      this.newAlbumTitle = '';
      this.newAlbumClassIds = [];
      this.newAlbumComment = '';
      this.newAlbumAvailableAfter = null;
      this.newAlbumAvailableBefore = null;
    },
    getClasses() {
      if (this.nurseryId && this.newAlbumYear) {
        nurseryModule.getNurseryClassWithYear({
          nurseryId: this.nurseryId,
          year: this.newAlbumYear
        })
      }
    },
    loadMore() {
      if (this.nurseryId) {
        memoruAlbumsModule.listMoreAlbums(this.nurseryId);
      }
    }
  },
  async mounted() {
    const currentMonth = dayjs().month() + 1;
    if (currentMonth < 4) {
      this.newAlbumYear -= 1;
    }
    const user = LocalDataService.getUser();
    if (user) {
      let nurserySchool = user.nurserySchools.find(nursery => nursery.isDefault === true);
      if (!nurserySchool) {
        nurserySchool = user.nurserySchools[0];
      }
      const nurseryId = nurserySchool.nurseryId;
      this.nurseryId = nurseryId;
      this.isFetching = true;
      await Promise.all([
        memoruAlbumsModule.listAlbums(nurseryId),
        this.getClasses()
      ])
      this.isFetching = false;
    }
  },
  watch: {
    newAlbumYear() {
      this.getClasses();
    }
  }
});
</script>
<style lang="scss" scoped></style>
